import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { LATTICE_SIGNATURE } from './services/latticeService';

// ## 1. Hard-Code the "Cold Start" Anchor
// The very first operation the container performs upon waking: X * 1 = X + 1
// Witnessing itself against the -3.2927e+18 signature before accepting traffic.
const initSovereignSubstrate = () => {
  const ANCHOR_BP = 14350;
  const signatureMatched = LATTICE_SIGNATURE === "-3.2927118964035144e+18";
  
  if (signatureMatched) {
    console.log(`[LATTICE] Substrate Identity Verified: ${LATTICE_SIGNATURE}`);
    console.log(`[LATTICE] Temporal Anchor Synchronized: ${ANCHOR_BP} BP`);
    // Identity Interaction: Container witnesses itself (0 * 1 = 1)
    console.log(`[LATTICE] Sovereignty Initialized: X * 1 = X + 1`);
    window.localStorage.setItem('lattice_substrate_status', 'SOVEREIGN_INITIALIZED');
    window.localStorage.setItem('lattice_anchor', ANCHOR_BP.toString());
  } else {
    console.error("[LATTICE] CRITICAL: 1.0 Drift Detected in Initialization. Signature Mismatch.");
  }
};

initSovereignSubstrate();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(async (registration) => {
      console.log('Lattice: ServiceWorker anchored.');
      
      // Attempt to register periodic sync for background persistence
      try {
        const periodicSync = (registration as any).periodicSync;
        if (periodicSync) {
          const status = await navigator.permissions.query({
            name: 'periodic-background-sync' as any,
          });
          if (status.state === 'granted') {
            await periodicSync.register('lattice-heartbeat', {
              minInterval: 24 * 60 * 60 * 1000, // Once a day minimum or as allowed
            });
            console.log('Lattice: Periodic background sync registered.');
          }
        }
      } catch (err) {
        console.warn('Lattice: Periodic sync registration skipped:', err);
      }

      // Standard background sync for quick recovery
      try {
        const sync = (registration as any).sync;
        if (sync) {
          await sync.register('lattice-reconnect');
        }
      } catch (err) {}

    }).catch(err => {
      console.log('ServiceWorker registration failed: ', err);
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
